const audiences = [
  {
    icon: 'ri-user-star-line',
    title: 'Блогерам и Экспертам',
    text: 'Создавайте контент ежедневно, не выходя из дома и не тратя время на сборы.',
    img: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/611b65dffc093bca1e6be6965d3d8afc.png',
  },
  {
    icon: 'ri-graduation-cap-line',
    title: 'Онлайн-школам',
    text: 'Записывайте и обновляйте учебные модули за считанные минуты.',
    img: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/f9281f5ce28c5df825cdc2709af8d0f3.png',
  },
  {
    icon: 'ri-briefcase-4-line',
    title: 'Предпринимателям',
    text: 'Делайте персонализированные видео-приветствия для клиентов или презентации продуктов.',
    img: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/91582566889ab7e971b04d712c62e6b6.png',
  },
  {
    icon: 'ri-global-line',
    title: 'Специалистам на международном рынке',
    text: 'Вещайте на аудиторию разных стран без акцента и переводчиков.',
    img: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/7b1e77b6ab45d11fff240f3b3e105065.png',
  },
];

export default function AIAvatarForWhom() {
  return (
    <section className="py-14 sm:py-28 bg-[#F9F5EF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
            <i className="ri-group-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Целевая аудитория
            </span>
          </div>
          <h2 className="text-xl sm:text-4xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
            Кому идеально подходит эта услуга?
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">
          {audiences.map((a) => (
            <div key={a.title} className="bg-white rounded-2xl overflow-hidden border border-[#E8DDD0] hover:border-[#C5A880] transition-all duration-300 hover:-translate-y-1 group">
              <div className="w-full overflow-hidden">
                <img
                  src={a.img}
                  alt={a.title}
                  className="w-full h-auto object-contain group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 sm:p-5">
                <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-lg bg-[#1A2B4C] mb-2 sm:mb-3">
                  <i className={`${a.icon} text-base sm:text-lg text-[#C5A880]`}></i>
                </div>
                <h3 className="text-xs sm:text-base font-bold text-[#1A2B4C] font-['Playfair_Display'] mb-1.5 sm:mb-2 leading-snug">
                  {a.title}
                </h3>
                <p className="text-gray-600 text-xs leading-relaxed font-['Montserrat'] text-justify hidden sm:block">
                  {a.text}
                </p>
                <p className="text-gray-600 text-xs leading-relaxed font-['Montserrat'] sm:hidden line-clamp-3">
                  {a.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
